import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { PageRepositoryService } from './shared/abstract-repository.service';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService extends PageRepositoryService<any> {
  protected baseUri = 'api/userInfo';

  constructor(protected http: HttpClient, protected authService: AuthService) {
    super(http);
  }

  updatePw(id: any, item: any): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.http
      .put<any>(`${this.apiServerUrl}/${this.baseUri}/updatePw/${id}`, item)
      .pipe(
        tap(() => {
          this.isLoadingSubject.next(false);
        }),
        this.handleError()
      );
  }

  /**
   * 구마모토 한인교류회 2024-04-01 행사 신청 가능한지 조회
   */
  getCanApply(): Observable<boolean> {
    return this.http
      .get<any>(`${this.apiServerUrl}/${this.baseUri}/canApply`)
      .pipe(this.handleError());
  }

  /**
   * 이메일 등록 여부 확인
   */
  checkExist(userId: string): Observable<any> {
    return this.http.get(`${this.apiServerUrl}/${this.baseUri}/checkExist`, {
      params: { userId },
    });
  }
}
